import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useBasket } from '../../contexts/BasketContext';
import { formatPrice } from '../../services/shopCatalog';
import styles from './Basket.module.css';

export const BasketIcon: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const { itemCount } = useBasket();

  return (
    <button className={styles.basketIconButton} onClick={onClick} aria-label="Basket">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="21" r="1" />
        <circle cx="20" cy="21" r="1" />
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
      </svg>
      {itemCount > 0 && <span className={styles.badge}>{itemCount}</span>}
    </button>
  );
};

export const BasketPopup: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { items, total } = useBasket();

  if (!isOpen) return null;

  return (
    <div className={styles.popup}>
      <div className={styles.popupHeader}>
        <span className={styles.popupTitle}>{t('shop.basket')}</span>
      </div>

      {items.length === 0 ? (
        <div className={styles.popupEmpty}>{t('shop.emptyBasket')}</div>
      ) : (
        <>
          <div className={styles.popupItems}>
            {items.map(item => (
              <div key={item.sku} className={styles.popupItem}>
                {item.imageUrl && (
                  <img src={item.imageUrl} alt={item.name} className={styles.popupItemImage} />
                )}
                <div className={styles.popupItemInfo}>
                  <div className={styles.popupItemName}>{item.name}</div>
                  {item.variantLabel && (
                    <div className={styles.popupItemVariant}>
                      {t('shop.variantWithLabel', { label: item.variantLabel })}
                    </div>
                  )}
                  <div className={styles.popupItemMeta}>
                    {item.quantity} &times; {formatPrice(item.price)}
                  </div>
                </div>
                <div className={styles.popupItemTotal}>
                  {formatPrice(item.price * item.quantity)}
                </div>
              </div>
            ))}
          </div>

          <div className={styles.popupFooter}>
            <div className={styles.popupTotal}>
              <span>{t('shop.total')}</span>
              <span className={styles.popupTotalValue}>{formatPrice(total)}</span>
            </div>
          </div>
        </>
      )}

      <Link
        to="/koszyk"
        className={styles.viewBasketLink}
        onClick={onClose}
      >
        {t('shop.viewBasket')}
      </Link>
    </div>
  );
};
